import { ApplicationState, CommanderThunkDispatch } from '@mews-commander/types';
import { canCurrentProfileViewSensitiveReports } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { isCurrentEnterpriseAnalyticsIntegrationEnabled } from '@mews-commander/legacy-entities/src/selectors';
import {
    clearPowerBiEmbeddedToken,
    fetchPowerBiEmbeddedTokenConfiguration,
    setAnalyticsType,
    startFetchingPowerBiEmbeddedToken,
    fetchAccountingConfig,
} from '../actions';
import AnalyticsType from '../enums/analyticsType';

export const fetchAnalytics = (dispatch: CommanderThunkDispatch, type: AnalyticsType) => {
    dispatch(setAnalyticsType(type));
    if (type === AnalyticsType.AgingBalance) {
        dispatch(fetchAccountingConfig());
    }
    dispatch(clearPowerBiEmbeddedToken());
    (dispatch(fetchPowerBiEmbeddedTokenConfiguration()) as $TSFixMe).then(() =>
        dispatch(startFetchingPowerBiEmbeddedToken())
    );
};

export const checkAnalyticsPrivilege = (state: ApplicationState) =>
    canCurrentProfileViewSensitiveReports(state) && isCurrentEnterpriseAnalyticsIntegrationEnabled(state, null);
